// Pure Monthly P&L / profitability calculation functions — no Firestore/React imports.
import { round } from "./whtCalculator";

// Net service revenue = SERVICE_CHARGE + MANAGEMENT_FEE + OTHER_REVENUE lines
// only (requirement 9/16) — the pass-through recovery lines (salary, EOBI,
// PESSI, etc.) are NOT revenue for this purpose, since ALM pays out the same
// amount it recovers for outsourced staff; they cancel out and are excluded
// here rather than netted against an unverified "actual cost" figure.
export function calculateGrossProfit({ netServiceRevenue, directCostVariance = 0 }) {
  return round(Number(netServiceRevenue || 0) - Number(directCostVariance || 0));
}

export function calculateOperatingProfit({ grossProfit, operatingExpenses }) {
  return round(Number(grossProfit || 0) - Number(operatingExpenses || 0));
}

// Gross billing view = every recognized line (service + all pass-through
// recovery categories), for finance's own reference — never presented as
// the P&L itself (requirement 17: "two views... never one as the statement").
export function sumGrossBilling(lines) {
  return round(lines.reduce((sum, line) => sum + Number(line.amount || 0), 0));
}

// Statutory control (EOBI/PESSI/salary charged-vs-paid, requirement 14).
// "Charged" here is what was recovered from clients via normalized invoice
// lines — there is no independently-verified "actual liability" figure yet
// (outsourced-staff EOBI/PESSI is computed once, at invoice time, and ALM
// pays out the same amount), so remainingPayable treats charged as the
// liability proxy until an actual-liability data source exists. This
// assumption is documented, not silent.
export function calculateStatutoryRemainingPayable({ charged, paid }) {
  return round(Number(charged || 0) - Number(paid || 0));
}

export function calculateMarginPercent({ grossProfit, netServiceRevenue }) {
  const revenue = Number(netServiceRevenue || 0);
  if (!revenue) return 0;
  return round((grossProfit / revenue) * 10000) / 100;
}
